import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { PatentAlteration } from 'src/types/api/patentRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: PatentAlteration;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利改請案 區塊。
 */
const InfoPatentAlteration: React.FC<Iprops> = ({
  data,
  isShow,
  setIsShow,
  colorType,
  noContent,
}) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  const SEPRATOR = ', '; //同格有複數資料的間隔符號

  return (
    <DropdownInfo
      title={`專利案件讓與紀錄`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      {data.alterations.map((item) => {
        return (
          <Table color={tableColor} key={item.sequence}>
            <Item>
              <Title>讓與序號</Title>
              <Content>{item.sequence}</Content>
              <Title>讓與人</Title>
              <Content>
                {item.transferers.map((transferer, index) => {
                  index += 1;
                  return index !== item.transferers.length
                    ? transferer.name + SEPRATOR
                    : transferer.name;
                }) || noContent}
              </Content>
            </Item>
            <Item>
              <Title>受讓人</Title>
              <Content>
                {item.transferees.map((transferee, index) => {
                  index += 1;
                  return index !== item.transferers.length
                    ? transferee.name + SEPRATOR
                    : transferee.name;
                }) || noContent}
              </Content>
            </Item>
          </Table>
        );
      })}
    </DropdownInfo>
  );
};

export default InfoPatentAlteration;
